import { API_DOMAIN } from 'constants/infograph';
import request from 'utils/request';

export type DocuSealCloneDocumentApiResponse = {
  id: number;
  slug: string;
  name: string;
  created_at: string;
  updated_at: string;
};

export type DocuSealValueData = {
  field: string;
  value: string;
};

export type DocuSealSubmitDocumentResponse = {
  id: number;
  submission_id: string;
  uuid: string;
  email: string;
  slug: string;
  sent_at: string | null;
  opened_at: string | null;
  completed_at: string | null;
  declined_at: string | null;
  created_at: string | null;
  updated_at: string | null;
  name: string | null;
  external_id: string | null;
  status: string;
  values: Array<DocuSealValueData>;
  role: string;
  embed_src: string;
};

/**
 *
 * @param token     string        jwt token
 * @returns docuseal api response
 */
export const cloneDocuSealDocument = async (token: string) => {
  const requestURL = `${API_DOMAIN}/cloneDocuSealDocument`;

  const headers = new Headers({
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  });

  return await request<DocuSealCloneDocumentApiResponse>(requestURL, {
    method: 'POST',
    headers: Object.fromEntries(headers),
  });
};
